import React from "react";

export default function Counterparties(props) {
    return props.data?.map((item) => (
        <div key={item.id} data-test-id="trip-planning-counterparty">
            {item.name}
        </div>
    ));
}
